import { usePolling, type UsePollingReturn } from "@/common/hooks/use-polling";

import { fetchWaitlistStats } from "./api";
import type { WaitlistStats } from "./types";

export interface UseWaitlistStatsReturn {
  stats: WaitlistStats | null;
  isLoading: boolean;
  error: string | null;
  refresh: () => void;
}

export function useWaitlistStats(): UseWaitlistStatsReturn {
  const polling: UsePollingReturn<WaitlistStats> = usePolling(fetchWaitlistStats, {
    fallbackErrorMessage: "Failed to load stats",
  });

  return {
    stats: polling.data,
    isLoading: polling.isLoading,
    error: polling.error,
    refresh: polling.refresh,
  };
}
